import { I18n } from '@calendly/i18n';
import { Tab, Tabs } from '@calendly/ui/components/tabs';
import { useEffect, useState } from 'react';
import { PreviewPanel } from '../components/preview_panel';
import { SectionMenu } from '../components/section_menu';
import { ActiveTabPanels } from '../tabs/active_tab_panels';
import { EDITOR_MODE } from '../use_editor_layout';
const layoutCss = "l1qzrhnf";
const bodyCss = "b1ew0xzt";
const contentCss = "csaab6e";
export const SmallLayout = ({
  activeTab,
  tabs,
  mode,
  onSelectTab,
  etLocks,
  lockingDisables,
  panelKeys,
  panelPropsByKey
}) => {
  const [isPreviewActive, setIsPreviewActive] = useState(false);
  const isMenuMode = mode === EDITOR_MODE.menu;

  // Exit preview on navigation — it's tied to the section, not the destination.
  useEffect(() => {
    setIsPreviewActive(false);
  }, [mode]);
  const renderBody = () => {
    if (isPreviewActive) return <PreviewPanel />;
    if (isMenuMode) return <SectionMenu tabs={tabs} onSelectTab={onSelectTab} />;
    return <main className={contentCss}>
        <ActiveTabPanels tabKey={activeTab.key} etLocks={etLocks} lockingDisables={lockingDisables} panelKeys={panelKeys} panelPropsByKey={panelPropsByKey} />
      </main>;
  };
  return <div className={layoutCss} data-testid="editor-small-layout">
      <Tabs underlined layout="spaced" aria-label={I18n.t('publisher.event_type_editor_crud.header.view_tabs_label')} data-testid="editor-view-tabs">
        <Tab selected={!isPreviewActive} data-testid="editor-view-tab-edit" onClick={() => setIsPreviewActive(false)}>
          {I18n.t('publisher.event_type_editor_crud.header.edit')}
        </Tab>
        <Tab selected={isPreviewActive} data-testid="editor-view-tab-preview" onClick={() => setIsPreviewActive(true)}>
          {I18n.t('publisher.event_type_editor_crud.header.preview')}
        </Tab>
      </Tabs>
      <div className={bodyCss} data-testid="editor-small-layout-body">
        {renderBody()}
      </div>
    </div>;
};

require("./small_layout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./small_layout.js");